export const isInWindow = (): boolean => typeof window !== 'undefined';
export const isInWorker = (): boolean => typeof WorkerGlobalScope !== 'undefined';
export const isInBrowser = (): boolean => isInWindow() || isInWorker();
